/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/JSONSerializationTypes.yaml
/**
Configuration used to serialize an object to json.
*/
export class ToJsonConfiguration {
    /** @param source {@displayType `DeepPartial<ToJsonConfiguration>`} */
    constructor(source = {}) {
        /**
          Serialize images in the object to json. If false, then fields that contain images are not serialized.
          
          Default is true
          */
        this.serializeImages = true;
        /**
          Image serialization mode.
          
          Default is REFERENCE
          */
        this.imageSerializationMode = 'REFERENCE';
        if (source.serializeImages !== undefined) {
            this.serializeImages = source.serializeImages;
        }
        if (source.imageSerializationMode !== undefined) {
            this.imageSerializationMode = source.imageSerializationMode;
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            serializeImages: this.serializeImages,
            imageSerializationMode: this.imageSerializationMode,
        };
    }
}
/** @hidden */
export const ImageSerializationModeValues = ['REFERENCE', 'BUFFER'];
//# sourceMappingURL=JsonSerializationTypes.js.map